import React from "react";
import PropTypes from "prop-types";
import { Checkbox } from "primereact/checkbox";
import { Label } from "../../../components/Inputs";

function SubscriptionForm({
  forwardedRef,
  className = "",
  model = {},
  disabled,
  onSave,
}) {
  const [state, setState] = React.useState({
    receiveSms: model.receive_sms === 1,
    receiveEmail: model.receive_email === 1,
  });

  React.useEffect(() => {
    setState((prev) => ({
      ...prev,
      receiveSms: model.receive_sms === 1,
      receiveEmail: model.receive_email === 1,
    }));
  }, [model]);

  const validate = React.useCallback(() => {
    const { receiveSms, receiveEmail } = state;
    return {
      id: model.id,
      receive_sms: receiveSms ? 1 : 0,
      receive_email: receiveEmail ? 1 : 0,
    };
  }, [state, model]);

  const getModel = React.useCallback(() => validate(), [validate]);
  React.useImperativeHandle(forwardedRef, () => ({ getModel }));

  const handleSave = React.useCallback(
    (key, value) => {
      setState((prev) => ({
        ...prev,
        [key]: value,
      }));
      if (onSave) {
        const model = getModel();
        model[key] = value ? 0 : 1;
        onSave(model);
      }
    },
    [getModel, onSave],
  );

  const { receiveEmail } = state;

  return (
    <div className={className}>
      <div className="w3-cell-row">
        <div className="w3-cell w3-cell-middle">
          <Label>{`Benachrichtigungen empfangen:`}</Label>
        </div>
        <div className="w3-cell w3-cell-middle">
          <div className="p-col-12- pad-sm-lr pad-btm w3-right">
            <Checkbox
              inputId={`receiveEmail`}
              value={receiveEmail}
              checked={receiveEmail}
              onChange={(event) => handleSave("receiveEmail", event.checked)}
              disabled={disabled}
            />
            <label htmlFor={`receiveEmail`} className="p-checkbox-label">
              {"per E-Mail"}
            </label>
          </div>
        </div>
      </div>
    </div>
  );
}

SubscriptionForm.propTypes = {
  className: PropTypes.string,
  model: PropTypes.shape({
    id: PropTypes.number,
    receive_email: PropTypes.number,
    receive_sms: PropTypes.number,
  }),
  onSave: PropTypes.func,
  disabled: PropTypes.bool,
};

export default React.forwardRef((props, ref) => (
  <SubscriptionForm {...props} forwardedRef={ref} />
));
